if (window.jQuery) {
  (function($) {
    $(function() {
      $('form').not('.double-click-ok').on('submit', function(ev) {
        var $buttons = $(ev.target).find('input[type="submit"], button[type="submit"]');
        $buttons.prop('disabled', true);
        setTimeout(function() {
          try {
            $buttons.prop('disabled', false);
          } catch(e) {}
        }, 3000);
      });
    });
  })(jQuery);
}


//////////////////
// WEBPACK FOOTER
// ./courses/static/courses/js-src/forgive-form-double-click.js
// module id = 8
// module chunks = 0